import { t } from "i18next";

export default function extractErrorMessage(err: any) {
  let errorMessage = t("Something_went_wrong");
  if (err?.message.includes("{")) {
    const parsedError = JSON.parse(err.message.split("\n")[1]); // Extract JSON part
    errorMessage = parsedError.message || errorMessage;
  }
  return err ? errorMessage : null;
}
